// src/utils/getExertionAdvice.js (or wherever this lives)
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../firebase/firebaseApp";

const fn = httpsCallable(
  getFunctions(firebaseApp, "europe-west2"),
  "generateExertionAdvice"
);

export async function getExertionAdvice({
  dateDisplay,
  rrBpm,
  br1min,
  br2min,
  rt90,
  rt95,
  rrHistory,
  activityDetails, // NEW
}) {
  const { data } = await fn({
    stats: {
      timestamp: dateDisplay,
      rrBpm: Number(rrBpm),
      br1min: Number(br1min),
      br2min: Number(br2min),
      rt90: String(rt90),
      rt95: String(rt95),
      rrHistory: Array.isArray(rrHistory) ? rrHistory : undefined,

      // Flattened, optional activity details
      activityTitle: activityDetails?.title ?? undefined,
      activityExercise: activityDetails?.exercise ?? undefined,
      activitySport: activityDetails?.sport ?? undefined,
      activityDurationMin:
        typeof activityDetails?.duration_min === "number"
          ? activityDetails.duration_min
          : undefined,
      activityIntensity: activityDetails?.intensity ?? undefined,
    },
  });

  console.log("getExertionAdvice", data);

  if (data?.error) throw new Error(data.error);
  return data;
}
